/* global document */
/* global TweenLite */
import { gsap } from 'gsap';

const createImageZoom = (id) => {
  const wrapper = document.getElementById(id);
  // If we split the renderer between fluid and solid
  // the following id will need to drop the -i suffex
  const zoom = document.getElementById(`${id}-izoom`);
  // ditto one less depth on the following
  const mainImg = wrapper.childNodes[0].childNodes[0];
  const enterTimeline = new gsap.timeline({ paused: true });
  const timer = gsap.delayedCall(1, () => enterTimeline.reverse()).pause();
  let wrapperRect;
  let ratio;

  function leaveAction() {
    enterTimeline.reverse();
  }

  function moveAction(e) {
    enterTimeline.play();
    timer.restart(true);
    const lx = wrapperRect.left;
    const ly = wrapperRect.top;
    let x;
    let y;
    if (e.touches) {
      x = e.touches.item(0).pageX;
      y = e.touches.item(0).pageY;
    } else {
      x = e.x;
      y = e.y;
    }
    const ex = x - lx;
    const ey = y - ly;
    gsap.set(zoom, { x: ex, y: ey });
    const zoomX = (-x * ratio) + (lx * ratio);
    const zoomY = (-y * ratio) + (ly * ratio);
    gsap.set(zoom, { backgroundPosition: `${zoomX}px ${zoomY}px` });
  }

  function getClientSize() {
    wrapperRect = wrapper.getBoundingClientRect();
  }

  function init() {
    getClientSize();
    ratio = mainImg.naturalWidth / wrapperRect.width;
    gsap.set(zoom, { xPercent: -50, yPercent: -50 });
    gsap.set(zoom, { autoAlpha: 0, scale: 0 });

    enterTimeline
      .to(zoom, 0.5, { autoAlpha: 1, scale: 1 }, 0);

    wrapper.addEventListener('mouseenter', getClientSize);
    wrapper.addEventListener('touchenter', getClientSize);
    wrapper.addEventListener('mouseleave', leaveAction);
    wrapper.addEventListener('touchend', leaveAction);
    wrapper.addEventListener('mousemove', moveAction);
    wrapper.addEventListener('touchmove', moveAction);
  }
  init();
};

export default createImageZoom;



// WEBPACK FOOTER //
// ./app/javascript/renderer/utils/imageZoomScript.js